import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';
import Editor from '@common/components/editor/editor.component';
import Field from '@common/components/validation/field.validation';
import React from 'react';
import autoBind from 'react-autobind';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  renderComponent() {
    const { props, validate } = this;
    const {
      TextoConsole,
      Sugestoes,
      Tema,
      Linguagem,
      Altura,
      MostrarConsole,
      isView,
      onExecute,
      onClearConsole,
      name,
      consoleButtons,
    } = props;

    return (
      <Field {...props} validate={validate}>
        {({ value, hasError, onChange, onBlur }) => {
          return (
            <LabeledInput {...props}>
              <Editor
                name={name}
                value={value || ''}
                consoleText={TextoConsole}
                theme={Tema || 'extendedLight'}
                language={Linguagem || 'language'}
                supportConstants={Sugestoes || []}
                onChange={onChange}
                onBlur={onBlur}
                onExecute={onExecute}
                onClearConsole={onClearConsole}
                consoleButtons={consoleButtons}
                isView={isView}
                height={Altura}
                hasError={hasError}
                showConsole={MostrarConsole === false ? false : true}
              />
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    const { Tema, Linguagem, Altura, MostrarConsole } = this.props;

    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <Editor
                value={field.value || ''}
                theme={Tema || 'extendedLight'}
                language={Linguagem || 'language'}
                isView={true}
                height={Altura}
                showConsole={MostrarConsole === false ? false : true}
              />
            </LabeledInput>
          );
        }}
      </Field>
    );
  }
}

DDadosComponent.defaultProps = {
  Tema: 'extendedLight',
  Linguagem: 'language',
  MostrarConsole: true,
};

export default DDadosComponent;
